import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema.ts';
import { type IQuestionWidget } from './IQuestionWidget.ts';

export const QuestionWidgetConfigSchema =
  CommonContainerWidgetConfigSchema.shape({
    title: RichTextAdvancedSchema.optional().label('Titolo'),
    description: RichTextAdvancedSchema.optional().label('Descrizione'),
    type: yup.string().exact(WidgetType.Question).required(),
  }) satisfies yup.ObjectSchema<IQuestionWidget>;

export interface IQuestionWidgetConfigComponentProps
  extends IWidgetComponentProps<IQuestionWidget> {}

export function QuestionWidgetConfigComponent(
  props: IQuestionWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      <FormItem name="title" label="Titolo">
        <RichTextAdvancedInput
          name="title"
          menus={MenuPresets.Inline}
          rows={3}
        />
      </FormItem>

      <FormItem name="description" label="Descrizione">
        <RichTextAdvancedInput
          name="description"
          menus={MenuPresets.Block}
          rows={10}
        />
      </FormItem>
    </div>
  );
}
